// Imports
import ___CSS_LOADER_API_SOURCEMAP_IMPORT___ from "../../node_modules/css-loader/dist/runtime/sourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../../node_modules/css-loader/dist/runtime/api.js";
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `/* ------------------------------------------------------------------
   Design tokens

   One accent colour, used sparingly. No two-colour gradients, no neon
   glow, no glass blur — those read as generic, and the typography and
   spacing should be carrying this instead.

   Swap the accent block below and the whole site follows.
------------------------------------------------------------------- */

:root {
  /* ---- Accent (the only chromatic colour in the system) ---- */
  --accent: #ff5c1a;
  --accent-hover: #ff7440;
  --accent-ink: #160c05;      /* text sitting on top of --accent */
  --accent-quiet: #ffb08a;    /* accent as text, when it needs to be legible */

  /* Reserved for real state, never decoration. */
  --ok: #57d9a3;
  --warn: #e9b949;
  --bad: #ff6b6b;

  /* ---- Surfaces: warm neutral, not blue-black ---- */
  --bg: #100f0e;
  --bg-elev: #171614;
  --surface: #1a1917;
  --surface-strong: #221f1d;
  --surface-hover: #2a2724;
  --line: #2b2926;
  --line-strong: #423e39;

  /* ---- Text ---- */
  --text: #f4f1ed;
  --text-soft: #b8b2a9;
  --text-dim: #8b847a;

  --shadow-sm: 0 1px 2px rgba(0, 0, 0, 0.5);
  --shadow-md: 0 10px 24px -12px rgba(0, 0, 0, 0.7);
  --shadow-lg: 0 24px 60px -28px rgba(0, 0, 0, 0.85);

  /* ---- Type ---- */
  --font-sans: "Space Grotesk", -apple-system, BlinkMacSystemFont, "Segoe UI",
    Roboto, "Helvetica Neue", Arial, sans-serif;
  --font-mono: "JetBrains Mono", ui-monospace, SFMono-Regular, "SF Mono", Menlo,
    Consolas, "Liberation Mono", monospace;

  --step--1: clamp(0.78rem, 0.76rem + 0.1vw, 0.84rem);
  --step-0: clamp(0.95rem, 0.92rem + 0.16vw, 1.05rem);
  --step-1: clamp(1.15rem, 1.08rem + 0.34vw, 1.35rem);
  --step-2: clamp(1.42rem, 1.28rem + 0.7vw, 1.9rem);
  --step-3: clamp(1.85rem, 1.55rem + 1.5vw, 2.9rem);
  --step-4: clamp(2.4rem, 1.7rem + 3.4vw, 4.6rem);
  --step-5: clamp(3rem, 1.6rem + 6.4vw, 7rem);

  /* ---- Space + shape ---- */
  --gutter: clamp(1.1rem, 0.6rem + 2.2vw, 2.5rem);
  --section-y: clamp(3rem, 2rem + 3.5vw, 5.5rem);
  --maxw: 1200px;
  --maxw-narrow: 760px;

  /* Squarer corners read as engineered; pills read as marketing. */
  --r-sm: 3px;
  --r-md: 5px;
  --r-lg: 7px;
  --r-xl: 10px;
  --r-pill: 999px;

  --ease: cubic-bezier(0.22, 1, 0.36, 1);
  --ease-in-out: cubic-bezier(0.65, 0, 0.35, 1);
  --dur: 0.42s;

  --nav-h: 68px;
  color-scheme: dark;
}

[data-theme="light"] {
  --accent: #b83304; /* 5.3:1 on --bg, 5.8:1 for ink on it */
  --accent-hover: #952a03;
  --accent-ink: #fffaf7;
  --accent-quiet: #a33206;

  --ok: #0f7a55;
  --warn: #8a6416;
  --bad: #c02b2b;

  --bg: #f3f1ed;
  --bg-elev: #ffffff;
  --surface: #ffffff;
  --surface-strong: #eceae5;
  --surface-hover: #e4e1da;
  --line: #dedad2;
  --line-strong: #b8b2a7;

  --text: #17150f;
  --text-soft: #4a463d;
  --text-dim: #6d685d;

  --shadow-md: 0 10px 24px -18px rgba(23, 21, 15, 0.4);
  --shadow-lg: 0 24px 60px -34px rgba(23, 21, 15, 0.35);
  color-scheme: light;
}
`, "",{"version":3,"sources":["webpack://./src/styles/tokens.css"],"names":[],"mappings":"AAAA;;;;;;;;qEAQqE;;AAErE;EACE,+DAA+D;EAC/D,iBAAiB;EACjB,uBAAuB;EACvB,qBAAqB,OAAO,oCAAoC;EAChE,uBAAuB,KAAK,gDAAgD;;EAE5E,+CAA+C;EAC/C,aAAa;EACb,eAAe;EACf,cAAc;;EAEd,qDAAqD;EACrD,aAAa;EACb,kBAAkB;EAClB,kBAAkB;EAClB,yBAAyB;EACzB,wBAAwB;EACxB,eAAe;EACf,sBAAsB;;EAEtB,mBAAmB;EACnB,eAAe;EACf,oBAAoB;EACpB,mBAAmB;;EAEnB,yCAAyC;EACzC,iDAAiD;EACjD,kDAAkD;;EAElD,mBAAmB;EACnB;+CAC6C;EAC7C;0CACwC;;EAExC,mDAAmD;EACnD,mDAAmD;EACnD,mDAAmD;EACnD,iDAAiD;EACjD,iDAAiD;EACjD,+CAA+C;EAC/C,2CAA2C;;EAE3C,4BAA4B;EAC5B,+CAA+C;EAC/C,8CAA8C;EAC9C,cAAc;EACd,oBAAoB;;EAEpB,iEAAiE;EACjE,WAAW;EACX,WAAW;EACX,WAAW;EACX,YAAY;EACZ,eAAe;;EAEf,sCAAsC;EACtC,6CAA6C;EAC7C,YAAY;;EAEZ,aAAa;EACb,kBAAkB;AACpB;;AAEA;EACE,iBAAiB,EAAE,uCAAuC;EAC1D,uBAAuB;EACvB,qBAAqB;EACrB,uBAAuB;;EAEvB,aAAa;EACb,eAAe;EACf,cAAc;;EAEd,aAAa;EACb,kBAAkB;EAClB,kBAAkB;EAClB,yBAAyB;EACzB,wBAAwB;EACxB,eAAe;EACf,sBAAsB;;EAEtB,eAAe;EACf,oBAAoB;EACpB,mBAAmB;;EAEnB,oDAAoD;EACpD,qDAAqD;EACrD,mBAAmB;AACrB","sourcesContent":["/* ------------------------------------------------------------------\n   Design tokens\n\n   One accent colour, used sparingly. No two-colour gradients, no neon\n   glow, no glass blur — those read as generic, and the typography and\n   spacing should be carrying this instead.\n\n   Swap the accent block below and the whole site follows.\n------------------------------------------------------------------- */\n\n:root {\n  /* ---- Accent (the only chromatic colour in the system) ---- */\n  --accent: #ff5c1a;\n  --accent-hover: #ff7440;\n  --accent-ink: #160c05;      /* text sitting on top of --accent */\n  --accent-quiet: #ffb08a;    /* accent as text, when it needs to be legible */\n\n  /* Reserved for real state, never decoration. */\n  --ok: #57d9a3;\n  --warn: #e9b949;\n  --bad: #ff6b6b;\n\n  /* ---- Surfaces: warm neutral, not blue-black ---- */\n  --bg: #100f0e;\n  --bg-elev: #171614;\n  --surface: #1a1917;\n  --surface-strong: #221f1d;\n  --surface-hover: #2a2724;\n  --line: #2b2926;\n  --line-strong: #423e39;\n\n  /* ---- Text ---- */\n  --text: #f4f1ed;\n  --text-soft: #b8b2a9;\n  --text-dim: #8b847a;\n\n  --shadow-sm: 0 1px 2px rgba(0, 0, 0, 0.5);\n  --shadow-md: 0 10px 24px -12px rgba(0, 0, 0, 0.7);\n  --shadow-lg: 0 24px 60px -28px rgba(0, 0, 0, 0.85);\n\n  /* ---- Type ---- */\n  --font-sans: \"Space Grotesk\", -apple-system, BlinkMacSystemFont, \"Segoe UI\",\n    Roboto, \"Helvetica Neue\", Arial, sans-serif;\n  --font-mono: \"JetBrains Mono\", ui-monospace, SFMono-Regular, \"SF Mono\", Menlo,\n    Consolas, \"Liberation Mono\", monospace;\n\n  --step--1: clamp(0.78rem, 0.76rem + 0.1vw, 0.84rem);\n  --step-0: clamp(0.95rem, 0.92rem + 0.16vw, 1.05rem);\n  --step-1: clamp(1.15rem, 1.08rem + 0.34vw, 1.35rem);\n  --step-2: clamp(1.42rem, 1.28rem + 0.7vw, 1.9rem);\n  --step-3: clamp(1.85rem, 1.55rem + 1.5vw, 2.9rem);\n  --step-4: clamp(2.4rem, 1.7rem + 3.4vw, 4.6rem);\n  --step-5: clamp(3rem, 1.6rem + 6.4vw, 7rem);\n\n  /* ---- Space + shape ---- */\n  --gutter: clamp(1.1rem, 0.6rem + 2.2vw, 2.5rem);\n  --section-y: clamp(3rem, 2rem + 3.5vw, 5.5rem);\n  --maxw: 1200px;\n  --maxw-narrow: 760px;\n\n  /* Squarer corners read as engineered; pills read as marketing. */\n  --r-sm: 3px;\n  --r-md: 5px;\n  --r-lg: 7px;\n  --r-xl: 10px;\n  --r-pill: 999px;\n\n  --ease: cubic-bezier(0.22, 1, 0.36, 1);\n  --ease-in-out: cubic-bezier(0.65, 0, 0.35, 1);\n  --dur: 0.42s;\n\n  --nav-h: 68px;\n  color-scheme: dark;\n}\n\n[data-theme=\"light\"] {\n  --accent: #b83304; /* 5.3:1 on --bg, 5.8:1 for ink on it */\n  --accent-hover: #952a03;\n  --accent-ink: #fffaf7;\n  --accent-quiet: #a33206;\n\n  --ok: #0f7a55;\n  --warn: #8a6416;\n  --bad: #c02b2b;\n\n  --bg: #f3f1ed;\n  --bg-elev: #ffffff;\n  --surface: #ffffff;\n  --surface-strong: #eceae5;\n  --surface-hover: #e4e1da;\n  --line: #dedad2;\n  --line-strong: #b8b2a7;\n\n  --text: #17150f;\n  --text-soft: #4a463d;\n  --text-dim: #6d685d;\n\n  --shadow-md: 0 10px 24px -18px rgba(23, 21, 15, 0.4);\n  --shadow-lg: 0 24px 60px -34px rgba(23, 21, 15, 0.35);\n  color-scheme: light;\n}\n"],"sourceRoot":""}]);
// Exports
___CSS_LOADER_EXPORT___.locals = {};
export default ___CSS_LOADER_EXPORT___;
